import React from 'react';
import { observer } from 'mobx-react-lite';
import { roundInfoStore, useTranslation } from '@pascal/pascal-core';

import Timer from '../timer/index';
import { WinPopUp } from '../index';
import { doBetStore } from '../../../store';
import { LastResultsCont } from '../lastResults';
import { globalTranslationKeys } from '../../../enums';
import BetPlaceInfo from '../../../components/common/betPlaceInfo';
import gameLogo from '../../../assets/images/game-magic-dice-logo.png';
import { BetSection, BetTypeSectionBottomRangeAndBtn } from '../../../components/common';

export const BetBlock = observer(() => {
  const t = useTranslation();
  const { winAmount } = doBetStore;
  const { roundId } = roundInfoStore;
  return (
    <div className='w-game-center-wrapper'>
      <div className='w-game-center-top'>
        <div className='game-round-id-wrp'>
          <div className='game-round-id'>
            <p className='g-r-p-id round'>{t(globalTranslationKeys.RoundId)}:</p>
            <p className='g-r-p-id'>{roundId}</p>
          </div>
        </div>
        <div className='game-logo-wrp '>
          <img src={gameLogo} alt='' />
        </div>
        <div className='web-wrap-svg'>
          <Timer />
        </div>
        <LastResultsCont />
      </div>
      <div className='w-game-center-bottom'>
        {winAmount ? <WinPopUp winAmount={winAmount} t={t} /> : <></>}
        <div className='w-md-bet-wrapper'>
          <BetPlaceInfo />
          <div className='w-md-bet-panel'>
            <BetTypeSectionBottomRangeAndBtn />
            <BetSection />
          </div>
        </div>
      </div>
    </div>
  );
});
